import React from 'react';
import { useParams } from 'react-router-dom';

import KeyChip from '@dashboard/components/KeyChip';
import Link from '@dashboard/components/mui-atoms/Link';
import { useGroupsListHref } from '@dashboard/hooks/route/hrefs';
import { Box, Breadcrumbs, Skeleton, Stack, Typography } from '@mui/material';

import CreateContactsGroupContact from './CreateContactsGroupContact';
import EditContactsGroupDialog from './EditContactsGroupDialog';
import useCurrentContactsGroup from './useCurrentContactsGroup';

export default function PageHeader() {
  const id = useParams<{ id: string }>().id!;
  const { data } = useCurrentContactsGroup();
  const groupsHref = useGroupsListHref();
  const model = data?.ContactsGroup;

  const renderHeadline = () => {
    if (model === undefined) {
      return <Skeleton />;
    }
    return (
      <Typography variant="h3" component="h1">
        {model.name}
      </Typography>
    );
  };

  const renderBreadcrumbs = () => {
    if (model === undefined) {
      return <Skeleton />;
    }

    const { key, id } = model;
    return (
      <Breadcrumbs separator="›">
        <Link href={groupsHref} variant="body2" color="text.secondary">
          Unsubscribe groups
        </Link>
        <Box pt={0.5}>
          <KeyChip label={key || id} />
        </Box>
      </Breadcrumbs>
    );
  };

  return (
    <Box pb={1.5}>
      {renderBreadcrumbs()}
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={2}
        justifyContent="space-between"
        alignItems={{ xs: 'left', md: 'center' }}
      >
        {renderHeadline()}
        <Stack spacing={1} direction="row">
          <CreateContactsGroupContact id={id} />
          <EditContactsGroupDialog />
        </Stack>
      </Stack>
    </Box>
  );
}
